import React, { useCallback } from "react";
import { useIntercom } from "react-use-intercom";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { FormState, Mode } from "../step-config-file/types";
import RadialPieChart from "./RadialChart";

interface FormComponentProps {
  formState: FormState;
  onFormChange: (newState: Partial<FormState>) => void;
}

export const ActionCard: React.FC<FormComponentProps> = ({
  formState,
  onFormChange,
}) => {
  const { showNewMessage } = useIntercom();

  const handleSelectChange = useCallback(
    (value: string) => {
      if (!value) return;
      onFormChange({ mode: value as Mode });
    },
    [onFormChange],
  );

  const handleSpeakToExpert = () => {
    showNewMessage(
      "I'd like to learn more about First Floor Elevation Insights",
    );
  };

  const menuItems: { key: string; value: string }[] = [
    { key: "First Floor Elevation", value: Mode.ffe },
    { key: "Feb. 2025 Event", value: Mode.real },
    { key: "2 Year", value: Mode.model_2 },
    { key: "5 Year", value: Mode.model_5 },
    { key: "10 Year", value: Mode.model_10 },
    { key: "20 Year", value: Mode.model_20 },
    { key: "50 Year", value: Mode.model_50 },
    { key: "100 Year", value: Mode.model_100 },
    { key: "500 Year", value: Mode.model_500 },
    { key: "1500 Year", value: Mode.model_1500 },
  ];

  return (
    <Card className="w-60 bg-card/95">
      <div className="flex items-center justify-center">
        <RadialPieChart data_key={formState.mode} />
      </div>
      <CardContent className="space-y-3">
        <div className="space-y-1.5">
          <Label>Flood Event</Label>
          <Select value={formState.mode} onValueChange={handleSelectChange}>
            <SelectTrigger className="w-full">
              <SelectValue />
            </SelectTrigger>
            <SelectContent position="popper">
              {menuItems.map((s) => (
                <SelectItem key={s.value} value={s.value}>
                  {s.key}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <Button className="w-full" onClick={handleSpeakToExpert}>
          Talk to an expert
        </Button>
      </CardContent>
    </Card>
  );
};
